import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * En-tête + navigation interne du domaine Groupe Prevention (Lot 9.0-E.I), affiché sur les 2 pages
 * racines (`/pilotage-prevention`, `/prevention-offres`) ET sur tous leurs écrans enfants non
 * embarqués (Bibliothèque, Catalogue des bilans, formulaire d'offre, Sites & tarifs) -- ces
 * derniers gardent EN PLUS leur propre `breadcrumb-bar` sous ce header (repère de profondeur),
 * jamais l'un à la place de l'autre. Écarté du lot 9.0-E.I initial pour éviter un double niveau de
 * navigation, réintroduit sur demande explicite : perdre ce header en descendant dans l'arbre
 * cassait le repère "je suis dans Prévention" plus qu'il n'évitait de la redondance.
 */
@Component({
  selector: 'app-prevention-group-header',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './prevention-group-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./prevention-group-header.component.scss'],
})
export class PreventionGroupHeaderComponent {
  @Input() activeTab: 'overview' | 'needs' | 'demand' | 'offers' = 'overview';
}
